import { useEffect, useState } from 'react'
import { store } from '@src/store'
import { useTranslation } from 'react-i18next'
import Modal from 'react-modal'
import { formatAmount } from '@src/reducers/wallet.reducer'

import classes from '../Modal/Modal.module.scss'
import { customModalStyles } from '../modalComponent/modalComponent'
import './SpecialBonusStamp.modules.scss'
import { BonusModal } from '../wallet/BonusModal'
import { Wallet } from '@src/reducers/wallet.reducer'
import { WebpLazyImage } from '../WebpLazyImage/WepbLazyImage'

export function SpecialBonusStamp({ me, isCollapsed }) {
  const [bonusModalOpen, setBonusModalOpen] = useState(false)
  const [show, setShow] = useState(false)
  const [bonusAmount, setBonusAmount] = useState(0)
  const [specialBonusData, setSpecialBonusData] = useState<any>(null)
  const [gamblerWallet, setGamblerWallet] = useState<Wallet>()
  const pendingKycBonuses = me?.pendingKycBonuses ?? []
  const hasPendingKycBonuses = pendingKycBonuses.length > 0

  useEffect(() => {
    const getBonusData = () => {
      if (me && store.getState().wallet.wallets.length > 0) {
        const gamblerWalletData = store.getState().wallet.wallets.find((w) => !!w.campaign?.meta?.playable)
        setGamblerWallet(gamblerWalletData)
        const specialBonus =
          hasPendingKycBonuses || !!gamblerWalletData
            ? {
                balance: gamblerWalletData?.balance || (pendingKycBonuses[0]?.amount ?? 0),
                currency: gamblerWalletData?.currency || (pendingKycBonuses[0]?.currency ?? 'BTC'),
              }
            : null
        setSpecialBonusData(specialBonus)
      }
    }
    const unsubscribe = store.subscribe(getBonusData)
    getBonusData()

    return () => unsubscribe()
  }, [, store.getState().wallet])

  useEffect(() => {
    if (gamblerWallet) {
      const multiplier = gamblerWallet.campaign?.payoutMultiplyer || 1
      const amount = gamblerWallet.campaign?.userInCampaign?.amount || 0
      setBonusAmount(amount)
      const wagered = gamblerWallet.campaign?.userInCampaign?.betSum ?? 0
      const toBeWagered = multiplier * amount
      const progress = (wagered / toBeWagered) * 100
      const win = progress >= 100
      setShow(win && specialBonusData)
    }
  }, [gamblerWallet])

  const { t } = useTranslation()

  return show ? (
    <>
      <Modal
        isOpen={bonusModalOpen}
        onRequestClose={() => setBonusModalOpen(false)}
        ariaHideApp={false}
        portalClassName={`${classes.root} ReactModalPortal wallet-overlay-portal`}
        id="wallet-modal-overlay"
        style={customModalStyles}
        contentLabel="Special Bonus Modal"
      >
        <BonusModal closeCallback={() => setBonusModalOpen(false)} />
      </Modal>
      {isCollapsed ? (
        <div className="specialCollapsed">
          <button onClick={() => setBonusModalOpen(true)}>
            <WebpLazyImage src="/public/assets/bonusMoney.png" />
          </button>
        </div>
      ) : (
        <div className="wrapper">
          <div className="special">
            <div className="specialLeft">
              <div className="specialOverflow text-yellow font-bold font-inter">
                {bonusAmount && specialBonusData?.currency ? formatAmount(bonusAmount, specialBonusData?.currency) : ''}
                &nbsp;
                {t('wallet.listView.bonus', 'Bonus')}
              </div>
              <span className="font-inter text-white">
                {t('menu.bonusMessage.unclaimedBonusDescription', 'You reached the wager amount!')}
              </span>
            </div>
            <button
              onClick={() => setBonusModalOpen(true)}
              className="nbbutton bg-gradient-to-r-custom font-semibold px-10 py-5 rounded-4 cursor-pointer"
            >
              {t('wallet.listView.specialBonusClaim', 'Claim')}
            </button>
          </div>
        </div>
      )}
    </>
  ) : null
}
